import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=1fe767b8&"
import script from "./TodoList.vue?vue&type=script&lang=js&"
export * from "./TodoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports